package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Moldova Flag (20x15dp)
 *
 * - ISO Alpha-2: MD
 * - ISO Alpha-3: MDA
 * - ISO Numeric: 498
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Moldova: ImageVector by lazy {
    ImageVector.Builder(
        name = "Moldova:MD:MDA:498:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD9071E)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(13f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(7f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFBCD17)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 0f)
                horizontalLineTo(14f)
                verticalLineTo(15f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFD1900)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.574f, 12.259f)
                lineTo(12.916f, 12.618f)
                lineTo(10.734f, 8.625f)
                lineTo(11.392f, 8.266f)
                lineTo(13.574f, 12.259f)
                close()
                moveTo(6.571f, 12.355f)
                lineTo(7.229f, 12.715f)
                lineTo(9.411f, 8.721f)
                lineTo(8.753f, 8.362f)
                lineTo(6.571f, 12.355f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFA77B3B)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.111f, 5.868f)
                verticalLineTo(9.338f)
                curveTo(7.111f, 10.108f, 6.448f, 11.113f, 6.113f, 11.487f)
                curveTo(5.778f, 11.86f, 5.113f, 12.716f, 5.113f, 12.716f)
                verticalLineTo(3.38f)
                curveTo(5.113f, 2.333f, 6.113f, 1.973f, 6.113f, 1.973f)
                curveTo(6.113f, 1.973f, 6.943f, 2.137f, 7.111f, 3.38f)
                verticalLineTo(4.591f)
                curveTo(7.368f, 4.794f, 8.226f, 5.414f, 8.78f, 5.152f)
                curveTo(9.438f, 4.841f, 9.665f, 3.949f, 9.665f, 3.949f)
                curveTo(9.665f, 3.949f, 9.604f, 3.049f, 9.334f, 3.049f)
                curveTo(9.064f, 3.049f, 9.042f, 1.782f, 10.076f, 1.782f)
                curveTo(11.11f, 1.782f, 11.231f, 2.27f, 11.231f, 2.66f)
                curveTo(11.231f, 2.864f, 11.067f, 3.192f, 10.911f, 3.504f)
                curveTo(10.77f, 3.787f, 10.635f, 4.057f, 10.635f, 4.209f)
                curveTo(10.635f, 4.53f, 10.877f, 5.152f, 11.231f, 5.152f)
                curveTo(11.479f, 5.152f, 12.673f, 4.688f, 13.363f, 4.411f)
                verticalLineTo(3.38f)
                curveTo(13.532f, 2.137f, 14.362f, 1.973f, 14.362f, 1.973f)
                curveTo(14.362f, 1.973f, 15.361f, 2.333f, 15.361f, 3.38f)
                verticalLineTo(12.716f)
                curveTo(15.361f, 12.716f, 14.696f, 11.86f, 14.362f, 11.487f)
                curveTo(14.027f, 11.113f, 13.363f, 10.108f, 13.363f, 9.338f)
                verticalLineTo(5.868f)
                horizontalLineTo(7.111f)
                close()
                moveTo(8.219f, 12.395f)
                curveTo(8.895f, 11.955f, 9.884f, 9.981f, 9.884f, 9.981f)
                lineTo(10.212f, 10.058f)
                curveTo(10.212f, 10.058f, 10.713f, 11.365f, 12.187f, 12.395f)
                curveTo(10.616f, 12.814f, 10.212f, 13.656f, 10.212f, 13.656f)
                curveTo(10.212f, 12.983f, 8.219f, 12.395f, 8.219f, 12.395f)
                close()
                moveTo(8.11f, 11.146f)
                curveTo(8.566f, 11.146f, 8.935f, 10.796f, 8.935f, 10.365f)
                curveTo(8.935f, 9.933f, 8.566f, 9.583f, 8.11f, 9.583f)
                curveTo(7.654f, 9.583f, 7.285f, 9.933f, 7.285f, 10.365f)
                curveTo(7.285f, 10.796f, 7.654f, 11.146f, 8.11f, 11.146f)
                close()
                moveTo(12.95f, 10.365f)
                curveTo(12.95f, 10.796f, 12.581f, 11.146f, 12.125f, 11.146f)
                curveTo(11.669f, 11.146f, 11.3f, 10.796f, 11.3f, 10.365f)
                curveTo(11.3f, 9.933f, 11.669f, 9.583f, 12.125f, 9.583f)
                curveTo(12.581f, 9.583f, 12.95f, 9.933f, 12.95f, 10.365f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFDFF00))) {
                moveTo(15.712f, 6.505f)
                lineTo(16.286f, 6.753f)
                lineTo(13.949f, 12.16f)
                lineTo(13.375f, 11.912f)
                lineTo(15.712f, 6.505f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE1E5E8)),
                fillAlpha = 0.3f,
                strokeAlpha = 0.3f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.9f, 4.896f)
                horizontalLineTo(13.5f)
                verticalLineTo(9.67f)
                curveTo(13.5f, 9.67f, 11.821f, 10.176f, 10.2f, 11.006f)
                curveTo(9.004f, 10.119f, 6.9f, 9.67f, 6.9f, 9.67f)
                verticalLineTo(4.896f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(6.9f, 4.896f)
                horizontalLineTo(13.5f)
                verticalLineTo(9.67f)
                curveTo(13.5f, 9.67f, 11.821f, 10.176f, 10.2f, 11.006f)
                curveTo(9.004f, 10.119f, 6.9f, 9.67f, 6.9f, 9.67f)
                verticalLineTo(4.896f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF3D58DB))) {
                moveTo(6.9f, 8.021f)
                horizontalLineToRelative(6.6f)
                verticalLineToRelative(3.125f)
                horizontalLineToRelative(-6.6f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFD1900))) {
                moveTo(6.9f, 4.896f)
                horizontalLineToRelative(6.6f)
                verticalLineToRelative(3.125f)
                horizontalLineToRelative(-6.6f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDFF00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.867f, 6.301f)
                lineTo(9.366f, 6.343f)
                lineTo(9.655f, 5.954f)
                lineTo(9.347f, 5.551f)
                lineTo(9.85f, 5.615f)
                lineTo(10.043f, 5.171f)
                lineTo(10.257f, 5.625f)
                lineTo(10.757f, 5.583f)
                lineTo(10.469f, 5.973f)
                lineTo(10.776f, 6.376f)
                lineTo(10.274f, 6.311f)
                lineTo(10.081f, 6.755f)
                lineTo(9.867f, 6.301f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDFF00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.969f, 5.42f)
                curveTo(8.969f, 5.42f, 7.625f, 6.237f, 8.073f, 6.824f)
                curveTo(8.521f, 7.411f, 9.085f, 7.486f, 9.085f, 7.486f)
                curveTo(9.085f, 7.486f, 7.71f, 9.548f, 10.129f, 10.726f)
                curveTo(12.719f, 9.589f, 11.357f, 7.486f, 11.357f, 7.486f)
                curveTo(11.357f, 7.486f, 12.155f, 7.31f, 12.314f, 6.675f)
                curveTo(12.474f, 6.041f, 11.272f, 5.313f, 11.272f, 5.313f)
                curveTo(11.272f, 5.313f, 12.022f, 6.4f, 11.851f, 6.675f)
                curveTo(11.679f, 6.951f, 10.762f, 7.231f, 10.129f, 7.231f)
                curveTo(9.496f, 7.231f, 8.518f, 7.053f, 8.361f, 6.572f)
                curveTo(8.203f, 6.091f, 8.969f, 5.42f, 8.969f, 5.42f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDFF00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.725f, 7.5f)
                lineTo(8.55f, 8.021f)
                lineTo(7.725f, 8.542f)
                lineTo(6.9f, 8.021f)
                lineTo(7.725f, 7.5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDFF00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.675f, 7.5f)
                lineTo(13.5f, 8.021f)
                lineTo(12.675f, 8.542f)
                lineTo(11.85f, 8.021f)
                lineTo(12.675f, 7.5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDFF00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.7f, 9.563f)
                curveTo(7.838f, 9.563f, 7.95f, 9.451f, 7.95f, 9.313f)
                curveTo(7.95f, 9.174f, 7.838f, 9.063f, 7.7f, 9.063f)
                curveTo(7.562f, 9.063f, 7.45f, 9.174f, 7.45f, 9.313f)
                curveTo(7.45f, 9.451f, 7.562f, 9.563f, 7.7f, 9.563f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDFF00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.019f, 9.089f)
                curveTo(12.804f, 8.915f, 12.475f, 8.966f, 12.284f, 9.202f)
                curveTo(12.093f, 9.438f, 12.112f, 9.77f, 12.326f, 9.944f)
                curveTo(12.443f, 10.039f, 12.382f, 9.663f, 12.559f, 9.425f)
                curveTo(12.707f, 9.224f, 13.117f, 9.169f, 13.019f, 9.089f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF048F02)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.96f, 7.206f)
            curveTo(2.96f, 7.206f, 3.619f, 7.984f, 4.24f, 7.73f)
            curveTo(4.86f, 7.475f, 4.71f, 6.562f, 4.71f, 6.562f)
            lineTo(4.24f, 6.988f)
            horizontalLineTo(3.84f)
            verticalLineTo(7.206f)
            lineTo(3.527f, 6.988f)
            verticalLineTo(7.206f)
            horizontalLineTo(2.96f)
            close()
            moveTo(3.406f, 8.403f)
            curveTo(3.406f, 8.403f, 4.209f, 9.103f, 4.75f, 8.905f)
            curveTo(5.291f, 8.707f, 5.155f, 7.759f, 5.155f, 7.759f)
            lineTo(4.685f, 8.185f)
            horizontalLineTo(4.285f)
            verticalLineTo(8.403f)
            lineTo(3.973f, 8.185f)
            verticalLineTo(8.403f)
            horizontalLineTo(3.406f)
            close()
            moveTo(5.568f, 9.992f)
            curveTo(5.027f, 10.19f, 4.224f, 9.489f, 4.224f, 9.489f)
            horizontalLineTo(4.791f)
            verticalLineTo(9.272f)
            lineTo(5.104f, 9.489f)
            verticalLineTo(9.272f)
            horizontalLineTo(5.504f)
            lineTo(5.974f, 8.846f)
            curveTo(5.974f, 8.846f, 6.109f, 9.794f, 5.568f, 9.992f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFDFF00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(8.737f, 1.405f)
            horizontalLineTo(8.112f)
            verticalLineTo(1.778f)
            horizontalLineTo(7.818f)
            verticalLineTo(2.403f)
            horizontalLineTo(8.112f)
            verticalLineTo(3.493f)
            horizontalLineTo(8.737f)
            verticalLineTo(2.403f)
            horizontalLineTo(9.095f)
            verticalLineTo(1.778f)
            horizontalLineTo(8.737f)
            verticalLineTo(1.405f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFDB4400)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(9.474f, 2.115f)
            lineTo(8.026f, 2.488f)
            lineTo(9.474f, 2.946f)
            verticalLineTo(2.115f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun MoldovaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Moldova,
            contentDescription = "Moldova Flag"
        )
    }
}
